export const _in = { y: 100, delay: 300, duration: 300 }
export const _out = { y: 100, duration: 300 }

export default {
  in : _in,
  out: _out
}
